import { Component, forwardRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ConfiguratorCompanyService, SelectItem } from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-select-company',
    templateUrl: './select-company.component.html',
    styleUrls: ['./select-company.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectCompanyComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SelectCompanyComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() disabled = false;
  @Input() group: string;
  @Input() onlyInput = true;

  companies: SelectItem[] = [];
  value: SelectItem | null = null;

  constructor(private companyService: ConfiguratorCompanyService) { }

  ngOnInit(): void {
    this.update();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.update();
  }

  private update(): void {
    if (this.group) {
      this.companyService.getAllCompaniesUsingGET(this.group).subscribe(companies => {
        this.companies = companies.map(l =>
          ({ label: l.name, value: l.id } as SelectItem)
        );
        if (this.value) {
          const selectedCompany = this.companies.find(
            company =>
              company.value === this.value?.value ||
              company.label === (this.value as SelectItem).label ||
              company.label === (this.value as SelectItem).value
          );
          if (selectedCompany) {
            this.writeValue(selectedCompany);
          } else if (this.companies.length === 1) {
            // UX: when there is only one possible company, select it automatically.
            this.writeValue(this.companies[0]);
          } else {
            this.writeValue(null);
          }
        } else if (this.companies.length === 1) {
          // UX: when there is only one possible company, select it automatically.
          this.writeValue(this.companies[0]);
        }
        this.onChange(this.value);
      });
    } else {
      this.companies = [];
      this.writeValue(null);
      this.onChange(this.value);
    }
  }

  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(item: SelectItem | null): void {
    this.value = item;
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean): void {
    this.disabled = disabled;
  }

  onSelect(event: SelectItem): void {
    this.writeValue(event);
    this.onChange(this.value);
  }
}
